import { defaultLicenseStatusFilters } from '../../../../../backend/extraTypes';
import { getLicenseCheckLatestStatusAnalyticsFunctionDef } from '../../../../../backend/features/credentialing-verification/shared/platform-function-types';
import { useCredentialingTranslation } from '../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useTypedPlatformFunctionResponse } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LicenseCheckAnalyticsGroupList } from './LicenseCheckAnalyticsGroupList';
export const LicenseCheckAnalyticsWidget = (props) => {
    const navigate = useNavigate();
    const [t] = useCredentialingTranslation();
    const { data: analytics } = useTypedPlatformFunctionResponse(getLicenseCheckLatestStatusAnalyticsFunctionDef, {});
    const navigateToDetailsTable = (detailsLink, status) => {
        const urlParams = new URLSearchParams();
        if (status && status.length > 0) {
            urlParams.set('filter', JSON.stringify({
                statuses: status,
            }));
        }
        navigate({ pathname: detailsLink, search: urlParams.toString() }, {
            state: {
                status: {
                    value: status,
                },
            },
        });
    };
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        }, "data-test": 'credentialing-analytics-widget' },
        React.createElement(Box, { sx: { display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'space-between', pb: 2 } },
            React.createElement(Typography, { variant: 'subtitle1', sx: { color: themeColors.text.main } }, t('licenseCheckAnalyticsWidget.title')),
            React.createElement(Link, { component: 'button', sx: {
                    cursor: 'pointer',
                    typography: 'button',
                }, onClick: () => {
                    navigateToDetailsTable(props.summaryPageRoute, defaultLicenseStatusFilters);
                }, "data-test": 'view-latest-link' }, t('licenseCheckAnalyticsWidget.viewLatest'))),
        React.createElement(LicenseCheckAnalyticsGroupList, { title: t('licenseCheckAnalyticsWidget.manual'), credentialType: 'manual', analytics: analytics === null || analytics === void 0 ? void 0 : analytics.manual, onCardClick: (filter) => navigateToDetailsTable(props.summaryPageRoute, filter) }),
        React.createElement(LicenseCheckAnalyticsGroupList, { title: t('licenseCheckAnalyticsWidget.automatic'), credentialType: 'automatic', analytics: analytics === null || analytics === void 0 ? void 0 : analytics.automatic, onCardClick: (filter) => navigateToDetailsTable(props.summaryPageRoute, filter) })));
};
